import { render, staticRenderFns } from "./userGameCoinRecord.vue?vue&type=template&id=2f0c2320&scoped=true&"
import script from "./userGameCoinRecord.vue?vue&type=script&lang=js&"
export * from "./userGameCoinRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c2320",
  null
  
)

export default component.exports